import { Text } from '@gluestack-ui/themed'

import React, { FunctionComponent, useEffect } from 'react'
import { Image, StyleSheet } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useDispatch, useSelector } from 'react-redux'
import { i18n } from '../../lib/i18n'
import { AuthenticationActions } from '../../redux/authentication/actions'
import { credentialsSelector } from '../../redux/authentication/selectors'
import { menuSelector } from '../../redux/menu/selector'
import { popToTop } from '../../services/navigation'
import { theme } from '../../theme'

const LOGO_HEIGHT = 76

const styles = StyleSheet.create({
  container: {
    maxWidth: '100%',
    flex: 1,
    alignContent: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.white,
  },
  logo: {
    height: LOGO_HEIGHT,
    width: '100%',
    marginBottom: theme.padding.x2,
  },
  text: {
    alignSelf: 'center',
  },
})

export const SignOut: FunctionComponent = () => {
  const menu = useSelector(menuSelector)
  const dispatch = useDispatch()
  const credentials = useSelector(credentialsSelector)

  useEffect(() => {
    if (credentials) dispatch(AuthenticationActions.logout(credentials.uuid, credentials.password))
    dispatch(AuthenticationActions.signInUser())
    const timer = setTimeout(popToTop, 1000)
    return () => clearTimeout(timer)
  }, [])

  const logoUri = menu && menu.header && menu.header.image

  return (
    <SafeAreaView edges={['bottom']} style={styles.container}>
      {!!logoUri && <Image style={styles.logo} source={{ uri: logoUri }} resizeMode="contain" />}
      <Text style={styles.text}>{i18n.t('signOut.disconnecing')}</Text>
    </SafeAreaView>
  )
}
